var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsPins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1066.646,
    height: 485.952,
    viewBox: "0 0 1066.646 485.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -31.214,
    y1: -2.169,
    x2: -31.036,
    y2: -2.136,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.78,
    y1: 0.147,
    x2: 0.091,
    y2: 0.994,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-111",
    cx: 0.27,
    cy: 0.243,
    r: 0.793,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd77d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ffd466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffd363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffd05a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffca4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ffc335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ffb919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.24,
    cy: 0.582,
    r: 0.623,
    gradientTransform: "matrix(0.708, -0.707, 0.381, 0.38, -49.316, -18.005)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pins",
    transform: "translate(-55.591 -289.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(527.881 641.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-2",
    "data-name": "Pin",
    transform: "translate(252.881 577.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-2",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-2",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-2",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-2",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-2",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-2",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-2",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-2",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-2",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-2",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-2",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-2",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-2",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-2",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-2",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-2",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-2",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-2",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-2",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-2",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-2",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-3",
    "data-name": "Pin",
    transform: "translate(194.881 469.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-3",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-3",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-3",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-3",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-3",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-3",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-3",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-3",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-3",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-3",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-3",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-3",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-3",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-3",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-3",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-3",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-3",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-3",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-3",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-3",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-3",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-4",
    "data-name": "Pin",
    transform: "translate(116.881 518.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-4",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-4",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-4",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-4",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-4",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-4",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-4",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-4",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-4",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-4",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-4",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-4",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-4",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-4",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-4",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-4",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-4",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-4",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-4",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-4",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-4",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-5",
    "data-name": "Pin",
    transform: "translate(99.881 501.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-5",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-5",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-5",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-5",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-5",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-5",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-5",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-5",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-5",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-5",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-5",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-5",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-5",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-5",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-5",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-5",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-5",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-5",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-5",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-5",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-5",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-6",
    "data-name": "Pin",
    transform: "translate(54.881 383.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-6",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-6",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-6",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-6",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-6",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-6",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-6",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-6",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-6",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-6",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-6",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-6",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-6",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-6",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-6",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-6",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-6",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-6",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-6",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-6",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-6",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-7",
    "data-name": "Pin",
    transform: "translate(567.881 662.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-7",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-7",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-7",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-7",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-7",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-7",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-7",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-7",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-7",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-7",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-7",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-7",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-7",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-7",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-7",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-7",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-7",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-7",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-7",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-7",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-7",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-8",
    "data-name": "Pin",
    transform: "translate(1108.036 289.241)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-8",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-8",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-8",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-8",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-8",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-8",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-8",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-8",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-8",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-8",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-8",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-8",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-8",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-8",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-8",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-8",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-8",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-8",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-8",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-8",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-8",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-9",
    "data-name": "Pin",
    transform: "translate(885.881 570.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-9",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-9",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-9",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-9",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-9",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-9",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-9",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-9",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-9",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-9",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-9",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-9",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-9",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-9",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-9",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-9",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-9",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-9",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-9",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-9",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-9",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-10",
    "data-name": "Pin",
    transform: "translate(1024.881 361.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-10",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-10",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-10",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-10",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-10",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-10",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-10",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-10",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-10",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-10",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-10",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-10",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-10",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-10",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-10",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-10",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-10",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-10",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-10",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-10",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-10",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-11",
    "data-name": "Pin",
    transform: "translate(1081.036 316.558)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-11",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-11",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-11",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-11",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-11",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-11",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-11",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-11",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-11",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-11",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-11",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-11",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-11",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-11",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-11",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-11",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-11",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-11",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-11",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-11",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-11",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-12",
    "data-name": "Pin",
    transform: "translate(1070.305 319.558)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-12",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-12",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-12",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-12",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-12",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-12",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-12",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-12",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-12",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-12",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-12",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-12",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-12",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-12",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-12",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-12",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-12",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-12",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-12",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-12",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-12",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-13",
    "data-name": "Pin",
    transform: "translate(1074.29 335.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-13",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-13",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-13",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-13",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-13",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-13",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-13",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-13",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-13",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-13",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-13",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-13",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-13",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-13",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-13",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-13",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-13",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-13",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-13",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-13",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-13",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-14",
    "data-name": "Pin",
    transform: "translate(1067.136 339.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-14",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-14",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-14",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-14",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-14",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-14",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-14",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-14",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-14",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-14",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-14",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-14",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-14",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-14",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-14",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-14",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-14",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-14",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-14",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-14",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-14",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-15",
    "data-name": "Pin",
    transform: "translate(1048.136 346.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-15",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-15",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-15",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-15",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-15",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-15",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-15",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-15",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-15",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-15",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-15",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-15",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-15",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-15",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-15",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-15",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-15",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-15",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-15",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-15",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-15",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-16",
    "data-name": "Pin",
    transform: "translate(1043.136 344.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-16",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-16",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-16",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-16",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-16",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-16",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-16",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-16",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-16",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-16",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-16",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-16",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-16",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-16",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-16",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-16",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-16",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-16",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-16",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-16",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-16",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-17",
    "data-name": "Pin",
    transform: "translate(1049.881 351.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-17",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-17",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-17",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-17",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-17",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-17",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-17",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-17",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-17",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-17",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-17",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-17",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-17",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-17",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-17",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-17",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-17",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-17",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-17",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-17",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-17",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-18",
    "data-name": "Pin",
    transform: "translate(1044.881 350.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-18",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-18",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-18",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-18",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-18",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-18",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-18",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-18",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-18",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-18",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-18",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-18",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-18",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-18",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-18",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-18",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-18",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-18",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-18",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-18",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-18",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-19",
    "data-name": "Pin",
    transform: "translate(1055.881 358.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-19",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-19",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-19",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-19",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-19",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-19",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-19",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-19",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-19",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-19",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-19",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-19",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-19",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-19",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-19",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-19",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-19",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-19",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-19",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-19",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-19",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-20",
    "data-name": "Pin",
    transform: "translate(963.881 690.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-20",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-20",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-20",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-20",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-20",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-20",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-20",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-20",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-20",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-20",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-20",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-20",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-20",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-20",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-20",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-20",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-20",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-20",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-20",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-20",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-20",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-21",
    "data-name": "Pin",
    transform: "translate(973.881 709.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-21",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-21",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-21",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-21",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-21",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-21",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-21",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-21",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-21",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-21",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-21",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-21",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-21",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-21",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-21",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-21",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-21",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-21",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-21",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-21",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-21",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-22",
    "data-name": "Pin",
    transform: "translate(987.881 735.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-22",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-22",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-22",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-22",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-22",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-22",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-22",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-22",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-22",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-22",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-22",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-22",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-22",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-22",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-22",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-22",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-22",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-22",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-22",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-22",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-22",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-23",
    "data-name": "Pin",
    transform: "translate(955.881 747.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-23",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-23",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-23",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-23",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-23",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-23",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-23",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-23",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-23",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-23",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-23",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-23",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-23",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-23",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-23",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-23",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-23",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-23",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-23",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-23",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-23",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-24",
    "data-name": "Pin",
    transform: "translate(936.881 714.875)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-24",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-24",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-24",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-24",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-24",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-24",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-24",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-24",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-24",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-24",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-24",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-24",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-24",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-24",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-24",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-24",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-24",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-24",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-24",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-24",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-24",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-25",
    "data-name": "Pin",
    transform: "translate(538.881 704.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-25",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-25",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-25",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-25",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-25",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-25",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-25",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-25",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-25",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-25",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-25",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-25",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-25",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-25",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-25",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-25",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-25",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-25",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-25",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-25",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-25",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pin-26",
    "data-name": "Pin",
    transform: "translate(607.881 697.534)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794-26",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522-26",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523-26",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524-26",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525-26",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526-26",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527-26",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528-26",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529-26",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530-26",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531-26",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532-26",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533-26",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534-26",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535-26",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536-26",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537-26",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538-26",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539-26",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541-26",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542-26",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsPins);
export default __webpack_public_path__ + "static/media/USPins.852be77f75c378d975031669ed717b60.svg";
export { ForwardRef as ReactComponent };